import * as React from 'react';

import { ShowMoreList } from '@coursera/cds-core';

import Faq from 'bundles/unified-seo-content-common/components/rich-text/Faq';
import { MAX_FAQS_TO_SHOW } from 'bundles/unified-seo-content-common/constants';
import type { Faq as FaqType } from 'bundles/unified-seo-content-common/types';

import _t from 'i18n!nls/articles';

type Props = {
  faqs: Array<FaqType | null>;
};

export const Faqs = ({ faqs }: Props) => {
  return (
    <ShowMoreList
      numItemsToShow={MAX_FAQS_TO_SHOW}
      controllerProps={{ itemTypePlural: _t('frequently asked questions') }}
    >
      {faqs.map((faq, i) => {
        if (!faq || !faq.question || !faq.answer) {
          return null;
        }

        return (
          <Faq
            key={`faq-${faq.sys.id}`}
            component="div"
            faq={{ question: faq.question, answer: faq.answer }}
            index={i}
          />
        );
      })}
    </ShowMoreList>
  );
};

export default Faqs;
